// Shift form rules mirrored from the backend (the server stays authoritative).

/** "8 h", "7 h 30 min". */
export function hoursText(minutes) {
  const total = Math.max(Math.round(Number(minutes) || 0), 0);
  const h = Math.floor(total / 60);
  const m = total % 60;
  return m ? `${h} h ${m} min` : `${h} h`;
}

function minutesOf(time) {
  const [h, m] = String(time || "").split(":").map(Number);
  return Number.isFinite(h) && Number.isFinite(m) ? h * 60 + m : null;
}

/**
 * Report 58: a shift has no grace of its own any more (the attendance pay policy sets it), an UNPAID break is at least
 * 20 minutes (a shorter rest is paid working time), and a shift schedules at most the statutory normal hours of paid
 * time a day. Returns the paid time worked out for the preview as well as the field errors.
 */
export function validateShiftForm(form, { normalDayMinutes = 480 } = {}) {
  const errors = {};
  if (!form.name?.trim()) errors.name = "Enter a shift name.";
  const start = minutesOf(form.start_time);
  const endWall = minutesOf(form.end_time);
  let end = endWall;
  if (start === null) errors.start_time = "Enter a start time.";
  if (end === null) errors.end_time = "Enter an end time.";
  if (start !== null && end !== null && start === end) errors.end_time = "End must differ from start.";
  const overnight = start !== null && end !== null && end < start;
  const breakMinutes = form.break_minutes === "" ? 0 : Number(form.break_minutes);
  if (!Number.isInteger(breakMinutes) || breakMinutes < 0 || breakMinutes > 240) {
    errors.break_minutes = "Use 0 to 240 minutes.";
  } else if (breakMinutes > 0) {
    let breakAt = minutesOf(form.break_start_time);
    if (breakAt === null) errors.break_start_time = "Enter when the break starts.";
    else if (start !== null && end !== null) {
      if (overnight) { end += 1440; if (breakAt < start) breakAt += 1440; }
      if (breakAt < start || breakAt + breakMinutes > end) errors.break_start_time = "The break must fit inside the shift.";
    }
  }
  const windowMinutes = start !== null && endWall !== null && start !== endWall ? (overnight ? endWall + 1440 : endWall) - start : 0;
  const breakPaid = Boolean(form.break_paid);
  const unpaidBreak = Number.isInteger(breakMinutes) && breakMinutes > 0 && !breakPaid ? breakMinutes : 0;
  const paidMinutes = Math.max(windowMinutes - unpaidBreak, 0);
  if (!errors.break_minutes && breakMinutes > 0 && !breakPaid && breakMinutes < 20) {
    errors.break_minutes = "A break under 20 minutes is paid working time. Tick \"The break is paid\", or make an unpaid meal break of at least 20 minutes.";
  }
  if (!errors.end_time && windowMinutes > 0 && paidMinutes > normalDayMinutes) {
    errors.end_time = `This shift has ${hoursText(paidMinutes)} of paid time. Normal hours are at most ${hoursText(normalDayMinutes)} a day: add the unpaid meal break, or shorten the shift.`;
  }
  return { errors, overnight, windowMinutes, unpaidBreak, paidMinutes };
}
